import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/contact-us.jpg'
import _imports_1 from '../images/business-icon.png'
import _imports_2 from '../images/book-icon.png'
import _imports_3 from '../images/plastics-title-bg.png'
import _imports_4 from '../images/closed.png'
import _imports_5 from '../images/succeed-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-7e4f7d91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "contact-us"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-con" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "CAREER")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "RECRUITMENT", -1))
const _hoisted_5 = { class: "main" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"contact-con-one\" data-v-7e4f7d91><div class=\"topBar\" data-v-7e4f7d91><p style=\"width:150px;\" data-v-7e4f7d91>Job title</p><p style=\"width:380px;\" data-v-7e4f7d91>Base Location</p><p style=\"width:200px;\" data-v-7e4f7d91>Number of Recruitment</p><p style=\"width:200px;\" data-v-7e4f7d91>Release time</p></div><div class=\"message\" data-v-7e4f7d91><p style=\"width:150px;\" data-v-7e4f7d91>Regional Manager</p><p style=\"width:380px;\" data-v-7e4f7d91>Singapore/Malaysia/Thailand/Vietnam/Indonesia</p><p style=\"width:200px;\" data-v-7e4f7d91>1</p><p style=\"width:200px;\" data-v-7e4f7d91>2022.5.25</p></div><div class=\"information-con-one\" data-v-7e4f7d91><div class=\"title\" data-v-7e4f7d91><img class=\"icon\" src=\"" + _imports_1 + "\" alt=\"business-icon\" data-v-7e4f7d91><span class=\"subtitle\" data-v-7e4f7d91>Regional Manager</span></div><p class=\"mation\" data-v-7e4f7d91>Report to：GM</p></div><div class=\"information-con-two\" data-v-7e4f7d91><div class=\"title\" data-v-7e4f7d91><img class=\"icon\" src=\"" + _imports_2 + "\" alt=\"book-icon\" data-v-7e4f7d91><span class=\"subtitle\" data-v-7e4f7d91>Responsibility</span></div><div class=\"mation-con\" data-v-7e4f7d91><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>1</p><p class=\"mation-content\" data-v-7e4f7d91>Responsible for the sales in local market with chemical, plastic, steel sheets materials;</p></div><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>2</p><p class=\"mation-content\" data-v-7e4f7d91>Support to reach the whole sales target;</p></div><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>3</p><p class=\"mation-content\" data-v-7e4f7d91>Develop the sales channels in local market, build and maintain the relationships with key cooperation partners, ensure the smooth running of the business project;</p></div><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>4</p><p class=\"mation-content\" data-v-7e4f7d91>Set up completed sourcing channels and sales channels;</p></div><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>5</p><p class=\"mation-content\" data-v-7e4f7d91>Responsible for relevant risk management.</p></div></div></div><div class=\"information-con-three\" data-v-7e4f7d91><div class=\"title\" data-v-7e4f7d91><img class=\"icon\" src=\"" + _imports_2 + "\" alt=\"book-icon\" data-v-7e4f7d91><span class=\"subtitle\" data-v-7e4f7d91>Requirements</span></div><div class=\"mation-con\" data-v-7e4f7d91><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>1</p><p class=\"mation-content\" data-v-7e4f7d91>Bachelor degree or above, prefer major in chemical material, petrochemical, metallurgy and so on;</p></div><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>2</p><p class=\"mation-content\" data-v-7e4f7d91>Command Chinese and local countries languages as working languages;</p></div><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>3</p><p class=\"mation-content\" data-v-7e4f7d91>Familiar with local market with rich resource of customers or channels; prefer experience as leader in middle or large level companies;</p></div><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>4</p><p class=\"mation-content\" data-v-7e4f7d91>Can take whole management and drive team with good command in chemical, plastic, steel sheet raw materials area;</p></div><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>5</p><p class=\"mation-content\" data-v-7e4f7d91>Skilled in communication, with strong sense of responsibility and implementation capacity;</p></div><div class=\"mation-list\" data-v-7e4f7d91><p class=\"number\" data-v-7e4f7d91>6</p><p class=\"mation-content\" data-v-7e4f7d91>Singaporean and other local nationalities or people who can stay locally are preferred.</p></div></div></div></div>", 1)
const _hoisted_7 = { class: "contact-con-two" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top",
  src: _imports_3,
  alt: "plastics-title-bg"
}, null, -1))
const _hoisted_9 = { class: "confirmation" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "meeting-title" }, "Leave your message", -1))
const _hoisted_11 = { class: "usermation" }
const _hoisted_12 = { class: "name-box" }
const _hoisted_13 = { class: "name-con" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "First name *", -1))
const _hoisted_15 = { class: "name-con" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Last name *", -1))
const _hoisted_17 = { class: "mail-box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mail" }, "Email address *", -1))
const _hoisted_19 = { class: "text-con" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content" }, "Content *", -1))
const _hoisted_21 = { class: "button-box" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Send")
const _hoisted_23 = {
  key: 0,
  class: "success-pop"
}
const _hoisted_24 = { class: "succeed" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top-img",
  src: _imports_3,
  alt: "plastics-title-bg"
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "succeed-icon",
  src: _imports_5,
  alt: "succeed-icon"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-one" }, "Sent Successfully", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-two" }, "Thank you for your submission and we will connect you as soon as possible", -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Define")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BackTop = _resolveComponent("BackTop")!
  const _component_ChatBox = _resolveComponent("ChatBox")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_CookieBox = _resolveComponent("CookieBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBar),
    _hoisted_2,
    _createVNode(_component_Breadcrumb),
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_input, {
                  class: "name-input",
                  modelValue: _ctx.firstName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_el_input, {
                  class: "name-input",
                  modelValue: _ctx.lastName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_el_input, {
                class: "email-input",
                modelValue: _ctx.emailAddress,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emailAddress) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_el_input, {
                class: "content-input",
                type: "textarea",
                resize: "none",
                rows: 4,
                modelValue: _ctx.content,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.content) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getMessage()))
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    (_ctx.succeedTag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("img", {
              class: "closed",
              src: _imports_4,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.succeedTag = 0)),
              alt: "closed"
            }),
            _hoisted_26,
            _hoisted_27,
            _hoisted_28,
            _createVNode(_component_el_button, {
              class: "define",
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.succeedTag = 0))
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_BackTop),
    _createVNode(_component_ChatBox),
    _createVNode(_component_Footer),
    _createVNode(_component_CookieBox)
  ]))
}